import styled from 'styled-components';
import { Modal, ModalBody } from 'reactstrap';

const StyledModal = styled(Modal)`
  .modal-content {
    border-radius: 0;

    .modal-body {
      @media only screen and (max-width: 550px) {
        font-size: .95rem;
      }
    }

    .modal-header {
      > h5 {
        font-weight: 600;
      }
  
      .close {
        outline: 0;
        margin: -0.75rem -1rem -1rem auto;
      }
    }
    
    .modal-footer {
      button {
        width: 7rem;
      }
    }
  }
`;

const StyledModalBody = styled(ModalBody)`
  font-size: 90%;
`;

export {
  StyledModal,
  StyledModalBody,
}